import NextImage from 'next/image';
import Link from 'next/link';

export function Header() {
  return (
    <header>
      <Link
        className='flex items-center gap-2 text-xl sm:text-3xl no-underline'
        href='/'
        style={{ textDecoration: 'none !important' }}
      >
        <NextImage alt='logo' src='/images/logos/logo-dark.png' width={44} height={39.5} />
        Therapy Animal Hub
      </Link>
    </header>
  );
}
